'use strict';

/**
 * @ngdoc function
 * @name gfcmsApp.controller:SettingsCtrl
 * @description
 * # SettingsCtrl
 * Controller of the gfcmsApp
 */
angular.module('gfcmsApp')
  .controller('SettingsCtrl', function($location, $routeParams, $controller, userService, FlashService, cfpLoadingBar,
  settingService, modalService) {

      var settingsVm = this;
      var rolesPermissions = [];

      $controller('BaseController', {
        vm: settingsVm
      });

      settingsVm.userData = {
        firstName: null,
        lastName: null,
        nickname: null,
        password: null,
        confirmPassword: null,
        roles: []
      };

      settingsVm.roles = [];
      settingsVm.permissions = [];

      settingsVm.baseActivate(activate);
      settingsVm.updatePermissionRoles = updatePermissionRoles;

      function activate() {
        getRoleClaimMatrix();
      }

      function getRoleClaimMatrix() {
        settingsVm.requestStart()
          .then(settingService.getRoleClaimMatrix)
          .then(function(response) {
            settingsVm.roles = response.roles;
            settingsVm.permissions = response.matrix;
          })
          .finally(settingsVm.requestComplete.bind(settingsVm));
      }

      function updatePermissionRoles() {
        var modalOptions = setupModalOptions();
        modalService.showModal({}, modalOptions)
          .then(function () {
              return settingsVm.requestStart(settingsVm)
                .then(settingService.updateRoleClaimMatrix.bind(null, settingsVm.permissions))
                .then(function(response) {
                  FlashService.Success('Role permissions updated');
                  $location.path('/users');
                })
                .catch(function(error) {
                  FlashService.Error('Role permissions update failed');
                })
                .finally(settingsVm.requestComplete.bind(settingsVm));
            });
      }

      function setupModalOptions() {
        return {
          closeButtonText: 'Cancel',
          actionButtonText: 'Yes',
          headerText: 'Save ACL?',
          bodyText: 'Incorrect ACL changes can potentially restrict' +
          ' access to all users in the system. Are you sure you want proceed?'
        };
      }
});
